export const CHARACTER_IMPORT_LIST_LABEL = "For import";
export const CHARACTER_NOT_IMPORT_LIST_LABEL = "Not for import";
